import React from 'react';

const BrandHeader = ({ subtitle }) => {
  return (
    <div className="text-center mb-8">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-[#D4AF37] rounded-2xl mb-4 shadow-lg shadow-[#D4AF37]/30">
        <span className="text-[#0A1628] font-black text-xl">OTG</span>
      </div>
      <h1 className="text-3xl font-black text-white tracking-tight">OnTheGo</h1>
      {subtitle && (
        <p className="text-[#D4AF37] text-sm font-medium mt-1 tracking-wider uppercase">{subtitle}</p>
      )}
    </div>
  );
};

export default BrandHeader;
